// import moment from 'moment';

export default function rejection({ next, store }) {
  if (store.getters['auth/active'] === 'off') {
    return next({ name: 'rejection' })
  }
  return next()
}
